// Every locale the site is prepared to render. Only "en" has real content today -- adding a
// language is: (1) add its code/label here, (2) add its dictionary to `dictionaries.ts`. No
// other code changes, since every component reads text through `t()` rather than literals.
export interface Locale {
  code: string;
  label: string;
}

export const LOCALES: Locale[] = [{ code: "en", label: "English" }];

export const DEFAULT_LOCALE = "en";
